/**
 * API RESPONSE
 */
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";

/**
 * UPDATE LOADING
 */
export const UPDATE_LOADING_STATE = "UPDATE_LOADING_STATE";
export const IS_COMPANY_LOADING = "IS_COMPANY_LOADING";
export const IS_COMPANY_LIST_TO_SWITCH_LOADING =
  "IS_COMPANY_LIST_TO_SWITCH_LOADING";
export const IS_COMPANY_UPDATE_LOADING = "IS_COMPANY_UPDATE_LOADING";

/**
 * UPDATE STATUS
 */
export const UPDATE_STATUS_STATE = "UPDATE_STATUS_STATE";
export const COMPANY_INVITE_STATUS = "COMPANY_INVITE_STATUS";
export const COMPANY_DELETE_STATUS = "COMPANY_DELETE_STATUS";

export const GET_COMPANY = "GET_COMPANY";
export const GET_COMPANY_LIST_TO_SWITCH = "GET_COMPANY_LIST_TO_SWITCH";
export const INVITE_COMPANY = "INVITE_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";

export const RESET_COMPANY_ERROR = "RESET_COMPANY_ERROR";
